import React from "react";
import { TabbedShowLayout, Tab, ShowProps } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import VehicleAssign from "./VehicleAssign";
import Financial from "./Financial";
import Timesheet from "./Timesheet";
import ShowWrapper from "../../components/ShowWrapper";

const SubcontractorShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    {
      title: "Subcontractors",
      link: `/subcontractors`,
    },
    {
      title: id,
      link: "",
    },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        actions={null}
        isHaveSchoolFilter
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Vehicle Assign">
                <VehicleAssign {...props} />
              </Tab>
              <Tab label="Financial">
                <Financial {...props} />
              </Tab>
              <Tab label="Timesheet">
                <Timesheet {...props} />
              </Tab>
              <Tab label="Internal Note">
                {/* <DistanceArea {...props} /> */}
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default SubcontractorShow;
